<dialog-draggable-header>Comments</dialog-draggable-header>
<div #content mat-dialog-content>

   <div class="h-100" >
      <data-table [data]="comments" [columns]="columns" (select)="onGridSelectionChange($event)"
         (edit)="saveHandler($event)" [loading]="loading" [paging]="true" [pageSize]="pageOptions.size"
         [defaultSortField]="pageOptions.sort" [totalRecords]="total" [lazy]="true" (lazyLoad)="onLazyLoad($event)" [filterColumnDisplay]="false">
         <ng-container actionStart>
            <button mat-button (click)="onAddCommentClick()" matTooltip="Click to add a comment.">Add Comment</button>
            <mat-divider vertical class="action-bar-vertical-divider"></mat-divider>
            <button mat-button (click)="removeHandler()" matTooltip="Click to delete the selected comment.">Delete Comment</button>
            <mat-divider vertical class="action-bar-vertical-divider"></mat-divider>
            <div>
               <mat-label class="display-field spacerLeft"> Checking Fixture No:
                  <span class="text-danger ">{{this.data.fixtureNo}}</span>
               </mat-label>
            </div>
            <mat-divider vertical class="action-bar-vertical-divider"></mat-divider>
            <div>
               <mat-label class="display-far"> Part No Lh or Single:
                  <span class="text-danger">{{this.data.partNumber}}</span>
               </mat-label>
            </div>

         </ng-container>
         <ng-container actionEnd>
            <button mat-dialog-close mat-button> Close </button>
         </ng-container>
      </data-table>
   </div>
</div>
